export const wait = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

export const formatTime = (ms: number) => {
	if (ms < 1000) return `${ms}-${ms * 2}ms`;
	if (ms < 60000) return `${Math.round(ms / 1000)}-${Math.round(ms / 1000) * 2}s`;
	if (ms < 3600000) return `${Math.round(ms / 60000)}-${Math.round(ms / 60000) * 2}m`;
	return `${Math.round(ms / 3600000)}h`;
};
